import { render } from "./dashboard-sidebar.vue?vue&type=template&id=27dc824d&scoped=true&ts=true"
import script from "./dashboard-sidebar.vue?vue&type=script&lang=ts"
export * from "./dashboard-sidebar.vue?vue&type=script&lang=ts"

import "./dashboard-sidebar.vue?vue&type=style&index=0&id=27dc824d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dc824d"]])

export default __exports__